/*****************************************************************
  Cookie Handling
******************************************************************/
function getCookie( cname ) {
	var name = cname + "=";
	var ca = document.cookie.split( ';' );
	for ( var i = 0; i < ca.length; i++ ) {
		var c = ca[ i ];
		while ( c.charAt( 0 ) == ' ' ) {
			c = c.substring( 1 );
		}
		if ( c.indexOf( name ) == 0 ) {
			return c.substring( name.length, c.length );
		}
	}
	return "";
}

function setCookie( cname, cvalue, exdays ) {
	var d = new Date();
	d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
/*****************************************************************
  END Cookie Handling
******************************************************************/

jQuery( document ).on( 'page.ready', function () {
	$ = jQuery;

	if ( $( 'main.homepage' ).length ) {
		console.log( 'This is the home page' );

		if ( getCookie( 'experienceLoader' ) == 'shown' ) {
			$( '.home-loader' ).css( 'display', 'none' );
			$( 'html,body' ).removeClass( 'noscroll' );
			$( 'header.home .container .bg' ).addClass( 'loaded' );
		} else {
			$( 'html,body' ).addClass( 'noscroll' );
			$( '.home-loader' ).css( 'display', 'block' );
			setTimeout( function () {
				$( 'html,body' ).stop().animate( { scrollTop: 0 }, 300, 'swing' );
			}, 100 );
		}

		var vid = $( '#loadervid' ).get( 0 );
		vid.addEventListener( 'ended', function () {
			$( '#loader' ).trigger( 'click' );
			setCookie( 'experienceLoader', 'shown', 7 );
		} )

		var smcontroller = new ScrollMagic.Controller();
		// Reset SMController for new page
		smcontroller.destroy( true );
		smcontroller = new ScrollMagic.Controller();

		$( 'section.intro-text .desc' ).each( function () {
			var me = $( this );

			new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: 0.7
				} )
				.on( 'enter', function ( event ) {
					$( me ).addClass( 'is-loaded' );

					$( 'h5 a' ).each( function ( index, el ) {
						setTimeout( function () {
							$( el ).addClass( 'highlight' );
						}, 1200 );
					} );
				} )
				.addTo( smcontroller );
		} );

		// Take care of page load experience
		// ---
		var $hl = $( '.home-loader .container' ),
			$maincontent = $hl.children( '.intro-content' ).children(),
			$logo = $maincontent[ 0 ],
			$text = $maincontent[ 1 ],
			$btn = $hl.children( '#loader' ),
			$bg = $hl.children( '.bg' );

		$( $logo ).addClass( 'showing' );

		setTimeout( function () {
			$( $logo ).addClass( 'hide' );
			$( $logo ).removeClass( 'showing' );
			$( $text ).removeClass( 'hide' );
			$( $btn ).removeClass( 'hide' );
		}, 2800 );

		$( '#loader' ).click( function ( event ) {
			setCookie( 'experienceLoader', 'shown', 7 );
			$( $bg ).addClass( 'godark' );

			setTimeout( function () {
				$( $text ).addClass( 'hide2' );
				$( $btn ).addClass( 'hide2' );

				setTimeout( function () {
					$( '.home-loader' ).addClass( 'thanos' );
					$( 'html,body' ).removeClass( 'noscroll' );
					$( 'header.home .container .bg' ).addClass( 'loaded' );
					setTimeout( function () {
						$( '.home-loader' ).css( 'display', 'none' );
					}, 400 );
				}, 1500 );

			}, 1800 );
		} );

		// Playlist Modal
		// ---
		function getIDfromYouTubeURL( url ) {
			var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
			var match = url.match( regExp );
			return ( match && match[ 7 ].length == 11 ) ? match[ 7 ] : false;
		}

		$( '.playlist-modal .playlist a' ).click( function ( e ) {
			e.preventDefault();

			$( '.playlist-modal .playlist a' ).removeClass( 'is-selected' );
			$( this ).addClass( 'is-selected' );

			$( '.playlist-modal .player' ).html( '<iframe src="https://www.youtube.com/embed/' + getIDfromYouTubeURL( $( this ).attr( 'href' ) ) + '?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>' );
		} );

		$( '#open-vids' ).click( function () {
			$( 'html' ).addClass( 'playlist-modal-open' );
			$( '.playlist-modal .playlist a:first-child' ).click();
		} );

	}

} );